import * as React from "react"

import { XBlockProps } from "react-xmasonry"
import { ICustomContentWidget } from "../../../../models"

interface Props extends XBlockProps {
    customContentWidget: ICustomContentWidget
}

export default class CustomContentWidget extends React.Component<Props> {
    render(): JSX.Element {
        const {
            customContentWidget: { id, label, content },
        } = this.props

        return (
            <div
                className="tw-mb-4 tw-mx-2 theme-bubble bg-cloud tw-px-2 tw-pb-2 tw-items-start"
                data-ft-custom-content-widget
                data-ft-id={id}
                data-ft-label={label}
            >
                <header className="step-header">
                    <h3 className="tw-my-2" data-ft-component="title">
                        {label}
                    </h3>
                </header>

                <div
                    className="tw-pb-6 tw-px-6 tw-whitespace-pre-line contentHasMaxFullWidth "
                    data-ft-component="content"
                    dangerouslySetInnerHTML={{ __html: content }}
                ></div>
            </div>
        )
    }
}
